// extracted by mini-css-extract-plugin
module.exports = {"SearchBar":"SearchBar_SearchBar__247b3","active":"SearchBar_active__a05eB"};